import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { FormSchemaV3, PreApproveType } from '../../../../../../../types/preloan/v3';
import PreApproveCarousel from '../../../../../../../components/PreApprove/PreApproveCarousel';
import { Partner, PartnerEntityConfig } from '../../../../../../../components/LeadFormIndex/types';
import HTMLParser from '../../../../../../../components/HTMLParser';
import ComplementOffer from '../../../../ComplementInvite/ComplementOffer';

export const getContactMessage = (partnerConfiguration: PartnerEntityConfig) => {
  let contactMessage = ' ';
  if (partnerConfiguration.contactEmail) {
    contactMessage += `puedes escribirnos a ${partnerConfiguration.contactEmail}`;
    if (partnerConfiguration.contactPhone) {
      contactMessage += ' o ';
    }
  }
  if (partnerConfiguration.contactPhone) {
    contactMessage += `puedes llamar al ${partnerConfiguration.contactPhone}`;
  }
  if (contactMessage === ' ') {
    contactMessage = ' contáctanos';
  }
  return contactMessage;
};

export const getRedirectUrl = (
  partnerConfiguration: PartnerEntityConfig,
  success: boolean,
) => {
  if (!partnerConfiguration.preLoanRequestConfig?.callbacks) {
    return partnerConfiguration.website || 'https://banca.me';
  }
  if (success) {
    return partnerConfiguration.preLoanRequestConfig?.callbacks?.success || (partnerConfiguration.website || 'https://banca.me');
  }
  return partnerConfiguration.preLoanRequestConfig?.callbacks?.failed || (partnerConfiguration.website || 'https://banca.me');
};

export const firstMessageSwitch = (params:{
  step: FormSchemaV3['step'],
  preApproves: PreApproveType[],
  firstMessage?: string,
  partner: Partner,
  token: string,
  complementOfferAvailable?: boolean,
  complementOfferPageCategory?: string,
  verificationPending?: boolean,
}) => {
  const {
    step, preApproves, firstMessage, partner,
    token, complementOfferAvailable, verificationPending,
    complementOfferPageCategory,
  } = params;
  const transferablePreApproves = preApproves
    .filter((preApprove) => preApprove.isTransferrable);
  const nonTransferablePreApproves = preApproves
    .filter((preApprove) => !preApprove.isTransferrable);
  const theme = useTheme();
  switch (step) {
    case 'WAITING_COMPANY_AFFILIATION':
      return (
        <b>
          Ahora nos pondremos en contacto con tu empleador.
          <span
            style={{ color: theme.palette.secondary.main }}
          >
            Si tu empresa decide unirse al convenio banca.me

          </span>
          {' '}
          , podrás tomar tu crédito con descuento directo de tu sueldo.
        </b>
      );
    case 'READY_FOR_LOAN':
      return (
        <>
          {firstMessage
          && (
          <Typography
            component="div"
            gutterBottom
          >
            <HTMLParser html={firstMessage} />
          </Typography>
          )}
          {preApproves.length > 0
          && !verificationPending
          && partner.config.preLoanRequestConfig?.lastStepText?.showPreApprove && (

            <PreApproveCarousel
              preApproves={nonTransferablePreApproves.length > 0
                ? nonTransferablePreApproves
                : transferablePreApproves}
              partner={partner}
              token={token}
            />
          )}
          {preApproves.some((preApprove) => preApprove.productType === 'mortgage')
          && !verificationPending
          && preApproves.length > 0
                  && preApproves.every((preApprove) => !preApprove.isTransferrable) && (
                    <Typography
                      style={{ marginTop: 5 }}
                      variant="caption"
                      align="center"
                      component="div"
                      gutterBottom
                    >
                      Esta simulación es referencial y
                      no representa una pre-aprobación de crédito hipotecario.
                    </Typography>
          ) }
          {complementOfferAvailable && (
            <ComplementOffer
              partner={partner}
              token={token}
              pageCategory={complementOfferPageCategory}
            />
          )}
        </>
      );

    case 'COMPANY_APROVE':
      return (
        <b>
          Con la información provista podremos
          {' '}
          <span
            style={{ color: theme.palette.secondary.main }}
          >
            atenderte y entregarte una evaluación

          </span>
          {' '}
          lo antes posible.
        </b>
      );
    case 'ARCHIVED_SUCCESS':
      return 'Según nuestros registros tu perfil se ha calificado y archivado como exitoso';
    default:
      return 'Te contactaremos pronto';
  }
};
export const secondMessageSwitch = (step: FormSchemaV3['step'], secondMessage?: string) => {
  switch (step) {
    case 'WAITING_COMPANY_AFFILIATION':
      return 'Si han pasado más de 5 días hábiles y no te hemos contactado,';
    case 'READY_FOR_LOAN':
      return secondMessage;
    case 'COMPANY_APROVE':
      return 'Si tienes alguna inquietud,';
    case 'ARCHIVED_SUCCESS':
      return 'Si no te ha llegado información sobre esto,';
    case 'MANUAL_VERIFICATION':
      return 'Si tienes alguna duda,';
    default:
      return 'Si no te hemos contactado,';
  }
};
